module.exports = __webpack_public_path__ + "static/media/emptyProductList.8d5ea3a1.svg";